import React from 'react';
import PropTypes from 'prop-types';

export default function IconIdea({size = '55px', color = '#303030'}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.38182 0C3.67273 0 4 0.109091 4.25455 0.254546C4.50909 0.436364 4.72727 0.654545 4.83636 0.945455C4.94545 1.23636 4.98182 1.52727 4.90909 1.85455C4.83636 2.14545 4.69091 2.43636 4.47273 2.65455C4.25455 2.87273 3.96364 3.01818 3.67273 3.09091C3.38182 3.16364 3.05454 3.12727 2.76364 3.01818C2.47273 2.90909 2.21818 2.69091 2.07273 2.43636C1.89091 2.18182 1.81818 1.89091 1.81818 1.56364C1.81818 1.16364 2 0.763636 2.29091 0.472727C2.58182 0.181818 2.98182 0 3.38182 0ZM6.25455 13.5636H0.981818C0.727273 13.5636 0.472727 13.4545 0.290909 13.2727C0.109091 13.0909 0 12.8364 0 12.5818C0 12.3273 0.109091 12.0727 0.290909 11.8909C0.472727 11.7091 0.727273 11.6 0.981818 11.6H2.65455V6.36364H1.70909C1.45455 6.36364 1.2 6.25455 1.01818 6.07273C0.836364 5.89091 0.727273 5.63636 0.727273 5.38182C0.727273 5.12727 0.836364 4.87273 1.01818 4.69091C1.2 4.50909 1.45455 4.4 1.70909 4.4H3.63636C3.89091 4.4 4.14545 4.50909 4.32727 4.69091C4.50909 4.87273 4.61818 5.12727 4.61818 5.38182V11.6364H6.29091C6.54545 11.6364 6.8 11.7455 6.98182 11.9273C7.16364 12.1091 7.27273 12.3636 7.27273 12.6182C7.27273 12.8727 7.16364 13.1273 6.98182 13.3091C6.76364 13.4545 6.50909 13.5636 6.25455 13.5636Z"
        fill={color}
      />
    </svg>
  );
}

IconIdea.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string
};
